import React from "react";
import { Carousel } from "@trendyol-js/react-carousel";
import { Link } from "react-router-dom";
import $ from "jquery";

/**
 * Componente para mostrar las News, estas se cargan a través de iteraciones tomando la 
 * información de las news desde el archivo .src/data/data.json -> "News"
 *
 * @component
 * @example
 * 
 * "News": [
    {
      "img": "img/news/01.webp",
      "imgHome": "img/news/01_home.webp",
      "text": "<b>Data Driven Marketing: personalizado, relevante y efectivo</b>",
      "shortText": "Data Driven Marketing",
      "new": true,
      "url": "/news/data-driven-marketing"
    }
  ]
 * 
 */

export const News = (props) => {
  const [width, setWidth] = React.useState(window.innerWidth);
  const [activeSlide, setActiveSlide] = React.useState(1);
  const breakpoint = 620;

  React.useEffect(() => {
    const saveWidth = () => {
      setWidth(window.innerWidth);
    };
    /* Inside of a "useEffect" hook add an event listener that updates
       the "width" state variable when the window size changes */
    window.addEventListener("resize", () => saveWidth);

    /* passing an empty array as the dependencies of the effect will cause this
       effect to only run when the component mounts, and not each time it updates.
       We only want the listener to be added once */
    return () => window.removeEventListener("resize", saveWidth);
  }, []);

  const handleClickRigth = () => {
    if (
      $('.styles-module_carousel-arrow__26sRw[data-direction="right"]').length >
      0
    )
      $(
        '.styles-module_carousel-arrow__26sRw[data-direction="right"]'
      )[0].click();
  };

  const handleClickLeft = () => {
    if (
      $('.styles-module_carousel-arrow__26sRw[data-direction="left"]').length >
      0
    )
      $(
        '.styles-module_carousel-arrow__26sRw[data-direction="left"]'
      )[0].click();
  };

  $(function() {
    if ($(".styles-module_item-tracker__3bypy")[0] !== undefined) {
      const observer = new MutationObserver((mutationList) =>
        mutationList
          .filter((m) => m.type === "childList")
          .forEach((m) => {
            if (
              $(m.target.childNodes[1])
                .children()
                .attr("class") !== undefined
            )
              setActiveSlide(
                parseInt(
                  $(m.target.childNodes[1])
                    .children()
                    .attr("class")
                ) + 1
              );
          })
      );
      observer.observe($(".styles-module_item-tracker__3bypy")[0], {
        childList: true,
        subtree: true,
      });
    }
  });

  if (props.data) {
    return (
      <div id="news">
        <div className="container-fluid padding-fluid">
          <hr className="hrGeneral"></hr>
          <br></br>
          <div className="row vertical-center-news1">
            <div className="col-xs-12 col-md-4 vertical-center-news2">
              <div
                className={
                  width < breakpoint
                    ? "col-xs-12 col-md-12 paddingRightLeft0"
                    : "col-xs-12 col-md-12 paddingRightLeft0 vertical-center"
                }
              >
                <div className="col-xs-5 col-md-5 paddingRightLeft0">
                  <h2>News</h2>
                  {width < breakpoint ? "" : <br></br>}
                </div>
                <div
                  className="col-xs-7 col-md-7 paddingRightLeft0"
                  style={{ display: width < breakpoint ? "none" : "block" }}
                >
                  <button
                    id="btnLeft"
                    aria-label="left"
                    type="button"
                    className="btn btn-custom"
                    onClick={handleClickLeft}
                  >
                    <i className="fa-solid fa-angle-left fa-xs"></i>
                  </button>{" "}
                  &nbsp;&nbsp;&nbsp;
                  <button
                    id="btnRigth"
                    aria-label="rigth"
                    type="button"
                    className="btn btn-custom"
                    onClick={handleClickRigth}
                  >
                    <i className="fa-solid fa-angle-right fa-xs"></i>
                  </button>
                </div>
                <div className="col-xs-12 col-md-12 news-text paddingRightLeft0">
                  {width < breakpoint ? (
                    <p>Las buenas nuevas y las grandes ideas</p>
                  ) : (
                    <p>
                      Las buenas nuevas<br></br> y las grandes ideas
                    </p>
                  )}
                </div>
              </div>
            </div>
            {/* <div className="col-xs-12 col-md-2 buttons" style={{ display: width < breakpoint ? 'none' : 'block'}}>
              <div>
                <button id="btnLeft" aria-label="left" type="button" className="btn btn-custom" onClick={handleClickLeft}>
                  <i className="fa-solid fa-angle-left fa-xs"></i>
                </button> &nbsp;&nbsp;&nbsp;
                <button id="btnRigth" aria-label="rigth" type="button" className="btn btn-custom" onClick={handleClickRigth}>
                  <i className="fa-solid fa-angle-right fa-xs"></i>
                </button>
              </div>
            </div> */}
            {width > breakpoint ? (
              <div id="dvCarousel" className="col-xs-12 col-md-8">
                <Carousel
                  show={width < breakpoint ? 1 : 1.7}
                  slide={1}
                  swipeOn={0.2}
                  transition={0.2}
                  swiping={true}
                  responsive={true}
                  infinite={true}
                  rightArrow={
                    width < breakpoint ? (
                      <div className="vertical-center-news1">
                        <div className="vertical-center-news2">
                          <button
                            aria-label="rigth"
                            type="button"
                            className="btn btn-custom vertical-center-button-news-rigth"
                          >
                            <i className="fa-solid fa-angle-right fa-xs"></i>
                          </button>
                        </div>
                      </div>
                    ) : null
                  }
                  leftArrow={
                    width < breakpoint ? (
                      <div className="vertical-center-news1">
                        <div className="vertical-center-news2">
                          <button
                            aria-label="rigth"
                            type="button"
                            className="btn btn-custom vertical-center-button-news-left"
                          >
                            <i className="fa-solid fa-angle-left fa-xs"></i>
                          </button>
                        </div>
                      </div>
                    ) : null
                  }
                >
                  {props.data.map((d, i) => (
                    <div key={`dv1${i}`} className={`${i}`}>
                      <Link to={d.url}>
                        <div key={`dv2${i}`} className="imgContainer">
                          {d.new ? (
                            <div key={`dv3${i}`} className="newContainer">
                              <div key={`dv4${i}`} className="new">
                                <p
                                  style={{
                                    margin: 0,
                                    fontSize: 16,
                                  }}
                                >
                                  Nuevo
                                </p>
                              </div>
                            </div>
                          ) : (
                            ""
                          )}
                          <img
                            className="img-responsive"
                            key={`img${i}`}
                            alt={d.text}
                            src={d.imgHome}
                          />
                          <span
                            className="textNews"
                            dangerouslySetInnerHTML={{ __html: d.text }}
                            key={`p${i}`}
                          ></span>
                        </div>
                      </Link>
                    </div>
                  ))}
                </Carousel>
                {/* <br></br>
                <br></br>
                 <div
                  className="col-md-12 col-xs-12 text-center"
                  style={{ position: "relative" }}
                >
                  <li className="carousel__indicator">
                    {props.data
                      ? props.data.map((d, i) => {
                          const count = i + 1;
                          return (
                            <span
                              className={`carousel__dot${
                                activeSlide === count ? " active" : ""
                              }`}
                              key={count}
                              // onClick={ () => setActiveSlide(count)}
                            />
                          );
                        })
                      : ""}
                  </li>
                </div> */}
              </div>
            ) : (
              ""
            )}
          </div>
        </div>

        {width < breakpoint ? (
          <div>
            <Carousel
              show={width < breakpoint ? 1 : 1.7}
              slide={1}
              swipeOn={0.2}
              transition={0.2}
              swiping={true}
              responsive={true}
              infinite={true}
              rightArrow={
                width < breakpoint ? (
                  <div className="vertical-center-news1">
                    <div className="vertical-center-news2">
                      <button
                        aria-label="rigth"
                        type="button"
                        style={{ position: "absolute" }}
                        className="btn btn-custom vertical-center-button-news-rigth"
                      >
                        <i className="fa-solid fa-angle-right fa-xs"></i>
                      </button>
                    </div>
                  </div>
                ) : null
              }
              leftArrow={
                width < breakpoint ? (
                  <div className="vertical-center-news1">
                    <div className="vertical-center-news2">
                      <button
                        aria-label="rigth"
                        type="button"
                        className="btn btn-custom vertical-center-button-news-left"
                      >
                        <i className="fa-solid fa-angle-left fa-xs"></i>
                      </button>
                    </div>
                  </div>
                ) : null
              }
            >
              {props.data.map((d, i) => (
                <div key={`dv1${i}`} className={`${i}`}>
                  <Link to={d.url}>
                    <div key={`dv2${i}`} className="imgContainer">
                      <img
                        className="img-responsive"
                        key={`img${i}`}
                        alt={d.text}
                        src={d.imgHome}
                      ></img>
                      <div
                        className="textNews"
                        dangerouslySetInnerHTML={{ __html: d.text }}
                        key={`p${i}`}
                      ></div>
                    </div>
                  </Link>
                </div>
              ))}
            </Carousel>
            {/* <br></br>
            <br></br>
            <div
              className="col-md-12 col-xs-12 text-center"
              style={{ position: "relative" }}
            >
              <li className="carousel__indicator">
                {props.data
                  ? props.data.map((d, i) => {
                      const count = i + 1;
                      return (
                        <span
                          className={`carousel__dot${
                            activeSlide === count ? " active" : ""
                          }`}
                          key={count}
                          // onClick={ () => setActiveSlide(count)}
                        />
                      );
                    })
                  : ""}
              </li>
            </div> */}
          </div>
        ) : (
          ""
        )}

        <div className="container-fluid padding-fluid">
          <hr className="hrGeneral"></hr>
          <br></br>
          <br></br>
          <div className="row">
            <div className="col-xs-12 col-md-12">
              <div id="briefcase" className="row">
                <div
                  id="idea"
                  className="col-xs-12 col-md-3 dv-idea text-center"
                >
                  <a
                    href="#0"
                    className="btn btn-custom btn-lg idea"
                    aria-label="idea"
                  >
                    {/* <i className="fa fa-lightbulb-o fa-2x"></i> */}
                    <img
                      alt="ram"
                      style={{ width: "23px" }}
                      src="img/light.png"
                    ></img>
                  </a>
                </div>
                <div className=" col-xs-12 col-md-9 text-idea">
                  <h2>
                    Una fórmula <br></br>integrada que desencadena <br></br>
                    valor&nbsp;&nbsp;
                    <a
                      id="ideaMobile"
                      href="#0"
                      className="btn btn-custom"
                      aria-label="idea"
                    >
                      <img
                        alt="ram"
                        style={{ width: "23px" }}
                        src="img/light.png"
                      ></img>
                    </a>
                  </h2>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  } else return <div></div>;
};
